// deepEqual: recursively checks for deep equality between two values.
function deepEqual(a, b) {
    // If the values are strictly equal, they are equal.
    if (a === b) return true;

    // If the types differ, they are not equal.
    if (typeof a !== typeof b) return false;

    // If one is null (and the other isn't), they're not equal.
    if (a === null || b === null) return false;

    // If both are arrays, compare lengths and each element.
    if (Array.isArray(a)) {
        if (!Array.isArray(b) || a.length !== b.length) return false;
        for (let i = 0; i < a.length; i++) {
            if (!deepEqual(a[i], b[i])) return false;
        }
        return true;
    }

    // If both are objects, compare keys and their values.
    if (typeof a === 'object') {
        const keysA = Object.keys(a);
        const keysB = Object.keys(b);
        if (keysA.length !== keysB.length) return false;
        for (let key of keysA) {
            if (!Object.prototype.hasOwnProperty.call(b, key)) return false;
            if (!deepEqual(a[key], b[key])) return false;
        }
        return true;
    }

    // Fallback for primitive types (should be caught by a === b above)
    return false;
}

// compareKeys: compares two objects based on a given array of keys.
export function compareKeys(obj1, obj2, keys) {
    for (let key of keys) {
        if (!deepEqual(obj1[key], obj2[key])) {
            return false;
        }
    }
    return true;
}